export const parseExpenseJson = (raw) => {
  if (raw == null || raw === "") return {};
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
};

export const sumDraftLineAmounts = (lines) => {
  const rows = Array.isArray(lines) ? lines : [];
  const debit = rows.reduce((acc, l) => acc + (Number(l?.debit) || 0), 0);
  const credit = rows.reduce((acc, l) => acc + (Number(l?.credit) || 0), 0);
  return Math.max(debit, credit);
};

/**
 * Importe mostrable de un ticket: prioriza el borrador contable guardado.
 * @param {object} row Documento con ExtractedJson / AccountingDraftJson
 */
export function resolveTicketAmount(row) {
  const extracted = parseExpenseJson(row?.ExtractedJson);
  const draft = parseExpenseJson(row?.AccountingDraftJson);
  const currency = String(draft?.currency || extracted?.currency || "EUR")
    .trim()
    .toUpperCase();

  const draftTotal = sumDraftLineAmounts(draft?.lines);
  if (draftTotal > 0) {
    return { total: draftTotal, currency };
  }

  const extractedTotal = Number(
    extracted?.total ??
      extracted?.totalAmount ??
      extracted?.amount ??
      extracted?.importe,
  );
  return { total: extractedTotal, currency };
}
